import { apiCall } from "../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);

export const getquickreportApi = async () => {
    try {
        const response = await get("report/get_report_type", { type: "quick" });
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    }
};
export const getReportAPi = async () => {
    try {
        const response = await get("report/get_report_type", { type: "Customized" });
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    }
};


export const exportquickApi = async (apivalue, formattedFromDate, formattedToDate, expected_date) => {
    try {
        return await post(`report/${apivalue}`, {
            from_date: formattedFromDate,
            to_date: formattedToDate,
            expected_date,
        });
    } catch (err) {
        console.error("Error fetching category:", err);
    }
};

export const exportCustomReportApi = async (apiType, body) => {
    try {
        return await post(`report/${apiType}`, body);
    } catch (err) {
        console.error("Error fetching category:", err);
    }
};


export const downloadBase64File = (base64String, fileName) => {
    const binary = atob(base64String);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(array)], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
